<template>
  <div>
    <header :class="{ 'head-active': headerActive }">
      <div class="header-con">
        <a class="logo" href="/">
          <img :src="logo" alt="" style="margin-right:20px">
          <img :src="logo2" alt="">
        </a>
        <div class="right-info">
          <nav>
            <ul>
              <li class="" @mouseenter="mouseEnter(0)" @mouseleave="mouseLeave(0)">
                <a :class="{ stair: true, active: this.activeIndex == '0' }" @click="jump('')" href="javascript:void(0)">首页</a>
              </li>
              <li class="" @mouseenter="mouseEnter('1')" @mouseleave="mouseLeave(0)">
                <a :class="{ stair: true, active: activeIndex == 1 }" @click="jump('product')" href="javascript:void(0)">产品介绍</a>
              </li>
              <li class="" @mouseenter="mouseEnter('2')" @mouseleave="mouseLeave(0)">
                <a :class="{ stair: true, active: activeIndex == 2 }" @click="jump('zhaoshangTitle')" href="javascript:void(0)">招商加盟</a>
              </li>
              <li class="" @mouseenter="mouseEnter('3')" @mouseleave="mouseLeave(0)">
                <a :class="{ stair: true, active: activeIndex == 3 }" @click="jump('introduce')" href="javascript:void(0)">关于我们</a>
              </li>

            </ul>
          </nav>
        </div>
      </div>
    </header>

    <!-- 回到顶部 -->
    <!-- <div class="back-top" :style="{display: 'block', opacity:headerActive?1:0}">
            <i class="el-icon-arrow-up" @click="scrollTop"></i>
        </div> -->
  </div>
</template>

<script>
import bus from '../../assets/bus.js';//引入中央总线Vue实例
export default {
  name: 'Head',
  components: {

    // import引入的组件需要注入到对象中才能使用
  },
  data() {
    return {
      logo: require('@/assets/img/logo.png'),
      logo2: require('@/assets/img/logo2.png'),
      headerActive: false,
      activeIndex: ''
    }
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 100) {
          this.headerActive = true
        }
        else {
          this.headerActive = false
        }
      })
    })

  },
  methods: {
    jump(target) {
      bus.$emit('scrollGo', { name: target })
    },
    mouseEnter(index) {
      this.activeIndex = index;
    },
    mouseLeave(index) {

      this.activeIndex = '';
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  },
}
</script>

<style scoped lang="less">
header {
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 20;
  transition: all 0.6s;
  .header-con {
    width: 70%;
    margin: 0 auto;
    line-height: 75px;
  }

  .logo {
    width: 450px;
    display: inline-block;
    position: relative;
    img {
      vertical-align: middle;
      height: 40px;
    }
  }

  .right-info {
    float: right;
    display: flex;
    flex-wrap: wrap;
    nav {

      ul {
        display: flex;

        li {
          a{
            cursor: pointer;
          }

          .stair {
            height: 75px;
            line-height: 75px;
            color: #fff;
            font-size: 16px;
            margin-left: 38px;
            margin-right: 38px;
            display: inline-block;
            position: relative;
          }

          .active2 {
            height: 80px;
            transition: all 0.5s;
          }

          a.stair:after {
            content: "";
            position: absolute;
            bottom: 0px;
            left: 0px;
            width: 100%;
            height: 2px;
            transform: scaleX(0);
            background-color: #1e5ef0;
            transition: all 0.5s;
          }

          a.active:after {
            transform: scaleX(1);
          }
        }
      }
    }
  }
}

header.head-active {
  background-color: #000;
  opacity: 0.7;
}

.back-top {
  width: 60px;
  height: 60px;
  line-height: 60px;
  background-color: #008cd6;
  text-align: center;
  position: fixed;
  right: 60px;
  bottom: 100px;
  z-index: 5;
  border-radius: 50%;
  box-sizing: content-box;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  -ms-transition: all 0.3s;
  transition: all 0.3s;
  display: none;

  i {
    font-size: 20px;
    color: #fff;
    font-weight: bold;
  }
}
@media screen and(max-width:1440px) {
  header {
    .header-con {
      width: 75%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue